import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the store product editor a "Catalog" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/catalog')({
  staticData: { crumb: 'common:nav.storeCatalog' },
  component: Outlet,
});
